import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { GripVertical } from 'lucide-react';

export default function SortableItem({ id, children, testId }) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    zIndex: isDragging ? 10 : 'auto',
  };
  return (
    <div ref={setNodeRef} style={style} className="relative flex items-stretch gap-2">
      <button
        type="button"
        {...attributes}
        {...listeners}
        className="flex items-center justify-center px-1 text-[#BDC3C7] hover:text-[#34495e] cursor-grab active:cursor-grabbing touch-none shrink-0 rounded-sm"
        data-testid={testId}
        aria-label="Drag to reorder"
      >
        <GripVertical size={16} />
      </button>
      <div className="flex-1 min-w-0">{children}</div>
    </div>
  );
}
